import { render, staticRenderFns } from "./UserResourcesACL.vue?vue&type=template&id=8c155628&scoped=true&"
import script from "./UserResourcesACL.vue?vue&type=script&lang=ts&"
export * from "./UserResourcesACL.vue?vue&type=script&lang=ts&"
import style0 from "./UserResourcesACL.vue?vue&type=style&index=0&id=8c155628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c155628",
  null
  
)

export default component.exports